import { h, Fragment } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';
import { Td } from './ShiftCalendarExtras';
import {
    returnInitFilter,
    arrangeCalendarVakter,
    sortThis
} from '../global/generalVariables';
import {
    returnDateInfo,
    datesAreOnSameDay,
    ISO8601_week_no
} from '../global/dateVariables';
import { CheckBox, Select, Slider } from '../global/generalComponentsInput';
import { Button, DeleteBtn } from '../global/generalComponentsButtons';
import { MenuDropdown } from './MenuDropdown';
import './ShiftCalendarComponent.scss';

const today = new Date();
const dateInfo = returnDateInfo(today);
const thisWeekNo = `${dateInfo.year}W${dateInfo.week}`;
const baseHeaderObj = {
    headerInf: [],
    yearHeaders: [],
    monthHeaders: [],
    weekHeaders: [],
    dayHeaders: []
};

const ShiftCalendarComponent = (props) => {
    const {
        vakter,
        dobbelpersonSchvid,
        dobbelvaktSchvid,
        minFilter,
        ignoreGoTo,
        setModalShow,
        setShowLeft,
        country,
        maxShow,
        setMaxShow,
        showLeft,
        zoomActive,
        saveZoomActivity,
        showFilter,
        filterAllChecked,
        offset,
        publicDash,
        yAxis,
        caseViewKalendar,
        noFilterBar,
        shiftweek,
        snapshot
    } = props;
    const [users, setUsers] = useState(
        ignoreGoTo
            ? []
            : JSON.parse(sessionStorage.getItem(`calendar-users-${country}`)) ||
                  []
    );
    const [bases, setBases] = useState(
        ignoreGoTo
            ? []
            : JSON.parse(sessionStorage.getItem(`calendar-bases-${country}`)) ||
                  []
    );
    const [rows, setRows] = useState(
        ignoreGoTo
            ? {}
            : JSON.parse(sessionStorage.getItem(`calendar-rows-${country}`)) ||
                  {}
    );
    const [rowArr, setRowArr] = useState([]);
    const [hasPersonFilter, setHasPersonFilter] = useState(
        ignoreGoTo
            ? false
            : JSON.parse(
                  sessionStorage.getItem(`calendar-hasPersonFilter-${country}`)
              ) || false
    );
    const [showOffset, setOffSet] = useState(
        offset
            ? offset
            : ignoreGoTo
            ? 0
            : JSON.parse(sessionStorage.getItem(`calendar-offset-${country}`))
    );
    const [headerArr, setHeaderArr] = useState(
        ignoreGoTo
            ? baseHeaderObj
            : JSON.parse(
                  sessionStorage.getItem(`calendar-headerArray-${country}`)
              ) || baseHeaderObj
    );
    const [filters, setFilters] = useState(
        returnInitFilter(
            minFilter,
            ignoreGoTo
                ? null
                : JSON.parse(sessionStorage.getItem('calendar-checkBoxFilter'))
        )
    );
    const [yAxisView, setYaxisView] = useState(
        yAxis
            ? yAxis
            : ignoreGoTo
            ? 'base'
            : JSON.parse(sessionStorage.getItem(`calendar-yAxis-${country}`)) ||
              'base'
    );
    const [hideFilters, setHideFilters] = useState(
        ignoreGoTo
            ? true
            : JSON.parse(
                  sessionStorage.getItem(`calendar-hideFilters-${country}`)
              ) || true
    );
    const [showExtraInfo, setShowExtra] = useState({ show: false, id: 0 });
    const [minimizeWindow, setMinimizeWindow] = useState(
        filterAllChecked
            ? false
            : ignoreGoTo
            ? true
            : JSON.parse(sessionStorage.getItem('calendar-minimizeWindow')) ||
              false
    );
    const [skillePerBT, setSKillePBT] = useState({});

    const buttons = [
        { title: '+ legg til', link: '/dashboard/ny-vakt' },
        {
            title: `+ legg til ${
                country == 'NO' ? 'kurs/samling' : 'kursus/samling'
            }`,
            link: '/dashboard/nytt-kurs'
        },
        {
            title: '+ legg til fravær/ferie',
            link: '/dashboard/nytt-fravaer&ferie'
        },
        country !== 'DK' && {
            title: '+ legg til flere',
            link: '/dashboard/legg-til-flere'
        },
        country === 'DK' && {
            title: '+ legg til flere 4-3',
            link: '/dashboard/legg-til-flere-4-3'
        },
        { title: '- fjern flere', link: '/dashboard/fjern-flere' },
        { title: '⇄ bytt mellom flere', link: '/dashboard/bytte-mellom-flere' }
    ].filter(Boolean);

    useEffect(() => {
        if (ignoreGoTo && !filterAllChecked) setMinimizeWindow(true);
        else
            setMinimizeWindow(
                JSON.parse(sessionStorage.getItem('calendar-minimizeWindow')) ||
                    false
            );
    }, [ignoreGoTo]);

    useEffect(() => {
        if (offset) setOffSet(offset);
    }, [offset]);

    useEffect(() => {
        if (filterAllChecked) {
            const newOb = { ...filters };
            Object.keys(newOb).forEach(function (key) {
                newOb[key].checked = true;
            });
            setFilters(newOb);
        }
    }, [filterAllChecked]);

    useEffect(() => {
        if (!ignoreGoTo && !shiftweek) {
            setUsers(
                JSON.parse(
                    sessionStorage.getItem(`calendar-users-${country}`)
                ) || []
            );
            setBases(
                JSON.parse(
                    sessionStorage.getItem(`calendar-bases-${country}`)
                ) || []
            );
            setRows(
                JSON.parse(
                    sessionStorage.getItem(`calendar-rows-${country}`)
                ) || {}
            );
            setHasPersonFilter(
                JSON.parse(
                    sessionStorage.getItem(
                        `calendar-hasPersonFilter-${country}`
                    )
                ) || false
            );
            setOffSet(
                JSON.parse(sessionStorage.getItem(`calendar-offset-${country}`))
            );
            setYaxisView(
                JSON.parse(
                    sessionStorage.getItem(`calendar-yAxis-${country}`)
                ) || 'base'
            );
            setHideFilters(
                JSON.parse(
                    sessionStorage.getItem(`calendar-hideFilters-${country}`)
                ) || true
            );
            setHeaderArr(
                JSON.parse(
                    sessionStorage.getItem(`calendar-headerArray-${country}`)
                ) || baseHeaderObj
            );
        }
    }, [country]);

    useEffect(() => {
        if (vakter && vakter.length != 0) doThings();
    }, [vakter, showOffset, filters, users, bases, yAxisView, maxShow]);

    useEffect(() => {
        if (!ignoreGoTo && !shiftweek) {
            if (!zoomActive && !showLeft) changeMaxShow(6);
            else if (!zoomActive && showLeft) changeMaxShow(4);
        }
    }, [showLeft, zoomActive]);

    const doThings = () => {
        let usrs = [];
        let bses = [];
        if (vakter.length > 0) {
            //only one time
            usrs = {};
            bses = {};
            vakter.forEach((vakt) => {
                if (
                    !(vakt.usid.toString() in usrs) &&
                    vakt.usid != 0 &&
                    vakt.navn
                ) {
                    const isChecked =
                        users.findIndex(
                            (el) => el.id === vakt.usid && el.checked === true
                        ) >= 0;
                    usrs[vakt.usid.toString()] = {
                        id: vakt.usid,
                        navn: vakt.navn,
                        nolas: vakt.nolas,
                        checked: isChecked,
                        disabled: false
                    };
                }
                let basId = `${vakt.base}${vakt.crewkd}`;
                if (!(basId in bses)) {
                    const basChecked =
                        bases.findIndex(
                            (el) => el.id === basId && el.checked === true
                        ) >= 0;
                    bses[basId] = {
                        id: basId,
                        navn: `${vakt.base} ${
                            vakt.crewkd == 10 ? 'HCM' : 'Pilot'
                        }`,
                        checked: basChecked,
                        disabled: false
                    };
                }
            });
            usrs = Object.values(usrs);
            if (usrs.length !== users.length) setUsers(usrs);

            bses = Object.values(bses);
            if (bases.length !== bses.length) setBases(bses);

            if (!ignoreGoTo && !shiftweek) {
                sessionStorage.setItem(
                    `calendar-bases-${country}`,
                    JSON.stringify(bses)
                );
                sessionStorage.setItem(
                    `calendar-users-${country}`,
                    JSON.stringify(usrs)
                );
            }
        }

        let filterUsr = usrs.length !== users.length ? [...usrs] : [...users];
        filterUsr = filterUsr.filter((fil) => fil.checked).map((itm) => itm.id);
        let filteredVakter = vakter;
        let filterBase = bses.length !== bases.length ? [...bses] : [...bases];
        filterBase = filterBase
            .filter((fil) => fil.checked)
            .map((itm) => itm.id);

        if (filterUsr.length > 0) {
            filteredVakter = vakter.filter((vkt) => {
                return filterUsr.includes(vkt.usid);
            });
        }
        if (filterBase.length > 0) {
            filteredVakter = filteredVakter.filter((vkt) => {
                return filterBase.includes(`${vkt.base}${vkt.crewkd}`);
            });
        }
        const workItms = arrangeCalendarVakter(
            filteredVakter,
            filters,
            yAxisView,
            showOffset,
            maxShow,
            ignoreGoTo,
            maxShow
        );

        if (
            filterUsr.length > 0 &&
            filterUsr.length <
                (usrs.length !== users.length ? usrs : users).length &&
            hasPersonFilter !== true
        ) {
            setHasPersonFilter(true);
            if (!ignoreGoTo && !shiftweek)
                sessionStorage.setItem(
                    `calendar-hasPersonFilter-${country}`,
                    JSON.stringify(true)
                );
        } else if (
            hasPersonFilter === true &&
            (filterUsr.length === 0 ||
                filterUsr.length >=
                    (usrs.length === users.length ? usrs : users).length)
        ) {
            setHasPersonFilter(false);
            if (!ignoreGoTo && !shiftweek)
                sessionStorage.setItem(
                    `calendar-hasPersonFilter-${country}`,
                    JSON.stringify(false)
                );
        }
        let headerArray = [];

        if (workItms && workItms.futureHeaders)
            headerArray = Object.values(workItms.futureHeaders);

        headerArray = sortThis(headerArray, {
            direction: 'asc'
        });
        //Fjerner overlapping der hvor det ikke skulle egentlig være det, ved å skyve vakten 1 plass må dermed skyve alle andre vakter som står på samme sted, slik at det ikke blir feil i visningen.
        if (maxShow >= 52) {
            for (const base in workItms.rowObj) {
                workItms.rowObj[base].shifts = sortThis(
                    workItms.rowObj[base].shifts,
                    {
                        key: 'start',
                        direction: 'asc'
                    }
                );
                workItms.rowObj[base].shifts.forEach((shift, index) => {
                    if (index != 0) {
                        if (!shift.isEmpty) {
                            if (
                                shift.start_iso ===
                                    workItms.rowObj[base].shifts[index - 1]
                                        .end_iso &&
                                shift.startColumn ==
                                    workItms.rowObj[base].shifts[index - 1]
                                        .startColumn
                            ) {
                                shift.startColumn += 1;
                            } else {
                                if (
                                    index != 1 &&
                                    shift.start_iso ===
                                        workItms.rowObj[base].shifts[index - 2]
                                            .end_iso &&
                                    shift.startColumn ==
                                        workItms.rowObj[base].shifts[index - 2]
                                            .startColumn
                                )
                                    shift.startColumn += 1;
                            }
                            if (
                                shift.start_iso ===
                                    workItms.rowObj[base].shifts[index - 1]
                                        .start_iso &&
                                shift.startColumn !=
                                    workItms.rowObj[base].shifts[index - 1]
                                        .startColumn
                            ) {
                                shift.startColumn =
                                    workItms.rowObj[base].shifts[
                                        index - 1
                                    ].startColumn;
                            }
                        }
                    }
                });
            }
        }
        setRows(workItms.rowObj);
        if (yAxisView == 'base') {
            let sortRowObj = [];
            let tempRowArr = [];
            let skillePerBasetype = {};
            sortRowObj = Object.entries(workItms.rowObj).sort(function (a, b) {
                var labelA = a[0],
                    labelB = b[0],
                    btA = a[1].basetype,
                    btB = b[1].basetype;

                if (btA == 4 && btB == 3) return -1;
                if (btA == 3 && btB == 4) return 1;
                if (btA == 7 && btB == 5) return -1;
                if (btA == 7 && btB == 6) return -1;
                if (btA == 5 && btB == 7) return 1;
                if (btA == 6 && btB == 7) return 1;
                if (btA < btB) return -1;
                if (btA > btB) return 1;
                if (btA == btB && labelA < labelB) return -1;
                if (btA == btB && labelA > labelB) return 1;
                return 0;
            });
            let prevBT = 0;
            sortRowObj.forEach((row) => {
                if (prevBT != 0) {
                    if (row[1].basetype != prevBT)
                        skillePerBasetype[row[0]] = true;
                    else skillePerBasetype[row[0]] = false;
                }
                tempRowArr.push(row[0]);
                prevBT = row[1].basetype;
            });

            setSKillePBT(skillePerBasetype);
            setRowArr(tempRowArr);
        } else {
            setRowArr(Object.keys(workItms.rowObj).sort());
        }
        if (!ignoreGoTo)
            sessionStorage.setItem(
                `calendar-rows-${country}`,
                JSON.stringify(workItms.rowObj)
            );
        if (headerArray.length > 0) {
            if (!ignoreGoTo && !shiftweek)
                sessionStorage.setItem(
                    `calendar-headers-${country}`,
                    JSON.stringify(workItms.futureHeaders)
                );

            setHeaderArr({
                headerInf: headerArray,
                yearHeaders: workItms.yearHeaders,
                monthHeaders: workItms.monthHeaders,
                weekHeaders: workItms.weekHeaders,
                dayHeaders: workItms.dayHeaders
            });
            if (!ignoreGoTo && !shiftweek)
                sessionStorage.setItem(
                    `calendar-headerArray-${country}`,
                    JSON.stringify(headerArray)
                );
            if (
                filterUsr &&
                filterUsr.length <= 0 &&
                filterBase &&
                filterBase.length <= 0
            ) {
                if (!ignoreGoTo && !shiftweek)
                    sessionStorage.setItem(
                        `calendar-changeHeaders-${country}`,
                        JSON.stringify(false)
                    );
            }
        }
    };

    const yAxsisChange = (val) => {
        setYaxisView(val.toLowerCase());
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(
                `calendar-yAxis-${country}`,
                JSON.stringify(val.toLowerCase())
            );
    };

    const offSetFix = (newVal) => {
        setOffSet(showOffset + newVal);
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(
                `calendar-offset-${country}`,
                JSON.stringify(showOffset + newVal)
            );
    };
    const changeCheckFilter = (value, obj) => {
        const newOb = { ...filters };
        newOb[obj].checked = value;
        setFilters(newOb);
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(
                'calendar-checkBoxFilter',
                JSON.stringify(newOb)
            );
    };
    const changeUser = (arr) => {
        setUsers(arr);
        if (!ignoreGoTo && !shiftweek) {
            sessionStorage.setItem(
                `calendar-users-${country}`,
                JSON.stringify(arr)
            );
        }
    };

    const changeBase = (arr) => {
        setBases(arr);
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(
                `calendar-bases-${country}`,
                JSON.stringify(arr)
            );
    };

    const changeMaxShow = (val) => {
        setMaxShow(val);
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(`calendar-maxshow`, JSON.stringify(val));
    };

    const resetFilter = () => {
        sessionStorage.removeItem('calendar-checkBoxFilter');
        sessionStorage.removeItem(`calendar-yAxis-${country}`);
        sessionStorage.removeItem(`calendar-users-${country}`);
        sessionStorage.removeItem(`calendar-rows-${country}`);
        sessionStorage.removeItem(`calendar-bases-${country}`);
        sessionStorage.removeItem('calendar-focus');
        sessionStorage.removeItem(`calendar-offset-${country}`);
        sessionStorage.removeItem(`calendar-headers-${country}`);
        sessionStorage.removeItem(`calendar-changeHeaders-${country}`);
        sessionStorage.removeItem(`calendar-hasPersonFilter-${country}`);
        sessionStorage.removeItem(`calendar-hideFilters-${country}`);
        sessionStorage.removeItem(`calendar-headerArray-${country}`);
        sessionStorage.removeItem('calendar-minimizeWindow');
        sessionStorage.removeItem('calendar-maxshow');
        setFilters(returnInitFilter(minFilter));
        setYaxisView('base');
        setUsers([]);
        setBases([]);
        if (typeof setShowLeft !== 'undefined') setShowLeft(true);
        setOffSet(0);
        setHasPersonFilter(false);
        setHideFilters(true);
        setHeaderArr(baseHeaderObj);
        setMinimizeWindow(false);
        setMaxShow(zoomActive ? 6 : showLeft ? 4 : 6);
    };

    const changeMinimizeView = (ch) => {
        setMinimizeWindow(!ch);
        if (!ignoreGoTo && !shiftweek)
            sessionStorage.setItem(
                'calendar-minimizeWindow',
                JSON.stringify(!ch)
            );
    };

    const idagKnapp = () => {
        setOffSet(0);
        sessionStorage.setItem(`calendar-offset-${country}`, JSON.stringify(0));
    };

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27 && zoomActive) {
            saveZoomActivity(false);
        }
    };
    return (
        <div
            className={`ShiftCalendarComponent ${
                zoomActive && !publicDash ? 'zoomEnable' : ''
            }`}
            style={`${
                caseViewKalendar ? 'display:block!important;width:100%;' : ''
            }`}
        >
            {zoomActive && !publicDash && !ignoreGoTo && !noFilterBar && (
                <MenuDropdown buttons={buttons} />
            )}
            {!noFilterBar && (
                <div
                    className={`filter-options${
                        hideFilters ? '' : ' show-all'
                    }`}
                >
                    <div className="spaceBetween">
                        <div>
                            {showFilter != false &&
                                Object.keys(filters)
                                    .sort(function (a, b) {
                                        if (a == 4 && b == 3) return -1;
                                        if (a == 3 && b == 4) return 1;
                                        if (a == 7 && b == 5) return -1;
                                        if (a == 7 && b == 6) return -1;
                                        if (a == 5 && b == 7) return 1;
                                        if (a == 6 && b == 7) return 1;
                                        if (a < b) return -1;
                                        if (a > b) return 1;
                                        return 0;
                                    })
                                    .map((filt) => (
                                        <CheckBox
                                            id={filters[filt]}
                                            name={filt}
                                            label={
                                                filters[filt].lbl == 'Kurs' &&
                                                country == 'DK'
                                                    ? 'Kursus'
                                                    : filters[filt].lbl
                                            }
                                            checked={filters[filt].checked}
                                            onChange={changeCheckFilter}
                                        />
                                    ))}
                        </div>
                        {!ignoreGoTo && (
                            <div className="besideFilter">
                                <button
                                    className="zoomInit zoomBorderFirst"
                                    onClick={() => idagKnapp()}
                                >
                                    {' '}
                                    Idag{' '}
                                </button>
                                <button
                                    className={`zoomInit ${
                                        zoomActive ? '' : 'zoomBorderLast'
                                    }`}
                                    onClick={() =>
                                        saveZoomActivity(!zoomActive)
                                    }
                                >
                                    {zoomActive ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            enable-background="new 0 0 20 21"
                                            height="20px"
                                            viewBox="0 0 20 21"
                                            width="21px"
                                            fill="#000000"
                                        >
                                            <path
                                                className="zoomSymbol"
                                                d="M22,3.41l-5.29,5.29L20,12h-8V4l3.29,3.29L20.59,2L22,3.41z M3.41,22l5.29-5.29L12,20v-8H4l3.29,3.29L2,20.59L3.41,22z"
                                            />
                                        </svg>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            enable-background="new 0 0 20 21"
                                            height="20px"
                                            viewBox="0 0 20 21"
                                            width="21px"
                                            fill="#000000"
                                        >
                                            <polygon
                                                className="zoomSymbol"
                                                points="21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71"
                                            />
                                        </svg>
                                    )}
                                </button>
                                {zoomActive &&
                                    [
                                        { weeks: 6, label: '6u' },
                                        { weeks: 7, label: '7u' },
                                        { weeks: 12, label: '3m' },
                                        { weeks: 26, label: '6m' },
                                        { weeks: 52, label: '1å' }
                                    ].map((elem) => (
                                        <button
                                            className={`zoomActive zoomInit ${
                                                elem.weeks == 52
                                                    ? 'zoomBorderLast'
                                                    : ''
                                            }`}
                                            id="otherZoom"
                                            onClick={() =>
                                                changeMaxShow(elem.weeks)
                                            }
                                        >
                                            {elem.label}
                                        </button>
                                    ))}
                            </div>
                        )}
                        {showFilter != false && ignoreGoTo && (
                            <CheckBox
                                id="calendar-maximize"
                                name="calendar-maximize"
                                label="Utvid rader"
                                checked={!minimizeWindow}
                                onChange={changeMinimizeView}
                            />
                        )}
                        <Slider
                            leftSide="base"
                            rightSide="crew"
                            value={yAxisView}
                            name="slide-calendar-view"
                            changeValue={yAxsisChange}
                        />
                        {publicDash && (
                            <div
                                style={`margin-top: ${
                                    snapshot ? '12.5em' : '9em'
                                };display: grid; grid-template-columns: 40px 40px 40px ;grid-gap: 5px;`}
                            >
                                {zoomActive &&
                                    [
                                        { weeks: 4, label: '4u' },
                                        { weeks: 7, label: '7u' },
                                        { weeks: 12, label: '3m' },
                                        { weeks: 26, label: '6m' },
                                        { weeks: 52, label: '1å' }
                                    ].map((elem) => (
                                        <button
                                            className={`zoomActive zoomInit ${
                                                elem.weeks == 52
                                                    ? 'zoomBorderLast'
                                                    : ''
                                            }`}
                                            id="otherZoom"
                                            onClick={() =>
                                                changeMaxShow(elem.weeks)
                                            }
                                        >
                                            {elem.label}
                                        </button>
                                    ))}
                            </div>
                        )}
                    </div>
                    {!ignoreGoTo && (
                        <Fragment>
                            <Select
                                label="Velg crew"
                                name="crewselect"
                                arrayToMap={users}
                                onChange={changeUser}
                                nameField="id"
                                labelField="navn"
                                isMultiple
                            />
                            <Select
                                label="Velg baser"
                                name="baseselect"
                                arrayToMap={bases}
                                onChange={changeBase}
                                nameField="id"
                                labelField="navn"
                                isMultiple
                            />
                            <div className="padding-div">
                                {!ignoreGoTo && (
                                    <CheckBox
                                        id="calendar-maximize"
                                        name="calendar-maximize"
                                        label="Utvid rader"
                                        checked={!minimizeWindow}
                                        onChange={changeMinimizeView}
                                    />
                                )}
                                <DeleteBtn
                                    label="nullstill filter"
                                    className="reset-filter"
                                    onClick={(_) => resetFilter()}
                                />
                            </div>
                        </Fragment>
                    )}
                    <Button
                        className="show-more-btn"
                        label=""
                        onClick={(_) => setHideFilters(!hideFilters)}
                    />
                </div>
            )}
            <div
                style={`${
                    caseViewKalendar
                        ? 'height:10vh!important;padding-top:0!important;'
                        : ''
                }`}
                className={`${shiftweek ? 'shift-wrapper' : 'scroll-wrapper'} ${
                    zoomActive ? 'zoom-wrapper' : ''
                }`}
            >
                <table>
                    <thead>
                        <tr className="grid-part">
                            <th className="base-header row-year"></th>
                            <th colSpan={maxShow}>
                                <div className={`show-${maxShow}`}>
                                    {headerArr &&
                                        headerArr.yearHeaders &&
                                        headerArr.yearHeaders.map((year) => {
                                            return (
                                                <p
                                                    style={`grid-column-start:${
                                                        year.startColumn || 1
                                                    };grid-column-end:${
                                                        year.endColumn || 2
                                                    }`}
                                                >
                                                    {year.year}
                                                </p>
                                            );
                                        })}
                                </div>
                            </th>
                        </tr>
                        <tr className="grid-part">
                            <th className="base-header"></th>
                            <th colSpan={maxShow} className="row-month">
                                <div className={`show-${maxShow}`}>
                                    {headerArr &&
                                        headerArr.monthHeaders &&
                                        headerArr.monthHeaders.map((month) => {
                                            return (
                                                <p
                                                    style={`grid-column-start:${
                                                        month.startColumn || 1
                                                    };grid-column-end:${
                                                        month.endColumn || 2
                                                    }`}
                                                >
                                                    {month.monthStr}
                                                </p>
                                            );
                                        })}
                                </div>
                            </th>
                        </tr>
                        <tr className="grid-part">
                            <th className="base-header row-week"></th>
                            <th colSpan={maxShow}>
                                <div className={`show-${maxShow}`}>
                                    {headerArr &&
                                        headerArr.weekHeaders &&
                                        headerArr.weekHeaders.map((week) => {
                                            return (
                                                <p
                                                    style={`grid-column-start:${
                                                        week.startColumn || 1
                                                    };grid-column-end:${
                                                        week.endColumn || 2
                                                    };${
                                                        week.week ==
                                                            ISO8601_week_no(
                                                                new Date()
                                                            ) &&
                                                        new Date().getFullYear() ==
                                                            week.year
                                                            ? 'border-bottom: 2px solid red;'
                                                            : ''
                                                    }`}
                                                >
                                                    {week.week}
                                                </p>
                                            );
                                        })}
                                </div>
                            </th>
                        </tr>
                        {maxShow <= 12 && (
                            <tr className="grid-part">
                                <th className="base-header row-day"></th>
                                <th colSpan={maxShow} className="row-day">
                                    <div className={`show-${maxShow}`}>
                                        {headerArr &&
                                            headerArr.dayHeaders &&
                                            headerArr.dayHeaders.map((day) => {
                                                return (
                                                    <p
                                                        style={`grid-column-start:${
                                                            day.startColumn || 1
                                                        };grid-column-end:${
                                                            day.endColumn || 2
                                                        };${
                                                            datesAreOnSameDay(
                                                                new Date(
                                                                    day.dateVar
                                                                ),
                                                                new Date()
                                                            )
                                                                ? 'border-bottom: 2px solid red;'
                                                                : ''
                                                        }`}
                                                    >
                                                        {day.day}
                                                    </p>
                                                );
                                            })}
                                    </div>
                                </th>
                            </tr>
                        )}
                    </thead>
                    <tbody
                        className={`show-${maxShow} ${
                            minimizeWindow ? 'tiny-view' : 'tall-view'
                        }`}
                    >
                        {rowArr.length > 0 ? (
                            <Fragment>
                                {rowArr.map((row) => (
                                    <Fragment>
                                        {' '}
                                        {rows[row].show && (
                                            <tr
                                                key={row}
                                                style={`${
                                                    skillePerBT &&
                                                    Object.keys(skillePerBT)
                                                        .length != 0 &&
                                                    skillePerBT[row]
                                                        ? 'border-top: 2px solid'
                                                        : ''
                                                }`}
                                            >
                                                <th
                                                    scope="row"
                                                    style={`${
                                                        shiftweek
                                                            ? 'vertical-align: middle;'
                                                            : ''
                                                    }`}
                                                >
                                                    {row}
                                                </th>
                                                <Td
                                                    shiftweek={shiftweek}
                                                    rows={rows}
                                                    row={row}
                                                    maxShow={maxShow}
                                                    dobbelpersonSchvid={
                                                        dobbelpersonSchvid
                                                    }
                                                    dobbelvaktSchvid={
                                                        dobbelvaktSchvid
                                                    }
                                                    showExtraInfo={
                                                        showExtraInfo
                                                    }
                                                    setShowExtra={setShowExtra}
                                                    ignoreGoTo={ignoreGoTo}
                                                    hasPersonFilter={
                                                        hasPersonFilter
                                                    }
                                                    setModalShow={setModalShow}
                                                    yAxisView={yAxisView}
                                                />
                                            </tr>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ) : (
                            <tr>
                                <td
                                    colSpan={maxShow + 1}
                                    style={`text-align: center;${
                                        shiftweek
                                            ? 'background-color:white !important; color:#5a5555 !important'
                                            : ''
                                    }`}
                                >
                                    Ingen rader å vise
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div
                    style={`${caseViewKalendar ? 'top:30px;' : ''}`}
                    className="one-back"
                    onClick={(_) => offSetFix(-1)}
                ></div>
                <div
                    style={`${caseViewKalendar ? 'top:30px;' : ''}`}
                    className="one-forward"
                    onClick={(_) => offSetFix(1)}
                ></div>
            </div>
        </div>
    );
};

export default ShiftCalendarComponent;
